module.exports = __webpack_public_path__ + "img/bg2.18fcf7d5.png";